import { ICoreContext } from '@msdyn365-commerce/core-internal';
import { normalizeUrl } from './url-helpers';

export const saveCookie = (cookieName: string, data: any, cookieExpiration = 30) => {
    clearCookie(cookieName);
    if (cookieExpiration < 0) {
        //If cookie expiration of less than 0 days is provided, we make a cookie that lasts forever
        document.cookie = `${cookieName}=${JSON.stringify(data)}; expires=Thu, 31 Dec 9999 23:59:59 GMT; path=/;`;
    } else {
        const currentDate = new Date();
        currentDate.setDate(currentDate.getDate() + cookieExpiration);
        const expirationDateInUtc = currentDate.toUTCString();
        document.cookie = `${cookieName}=${JSON.stringify(data)}; expires=${expirationDateInUtc}; path=/;`;
    }
};

export const getCookie = (cname: string) => {
    const name = `${cname}=`;
    const decodedCookie = decodeURIComponent(document.cookie);
    const ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
            return c.substring(name.length, c.length);
        }
    }
    return '';
};
export const clearCookie = (cookieName: string, path?: string) => {
    document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC;${path ? ` path=${normalizeUrl(path)}` : ''}`;
};

// This allows using the cookie value in server side components
export const getCookieValueFromContext = <T = string>(cookieName: string, context: ICoreContext): T | undefined => {
    const cookieContext = context.actionContext.requestContext.cookies;
    return cookieContext.get(cookieName).value as T | undefined;
};

interface UCServiceInfo {
    categorySlug: 'essential' | 'marketing' | 'functional';
    consent: {
        status: boolean;
    };
}
type WindowWithUCUI = Window &
    typeof globalThis & {
        UC_UI: {
            getServicesBaseInfo: () => Promise<UCServiceInfo[]>;
        };
    };
const hasUCUILoaded = (w: any): w is WindowWithUCUI => {
    return 'UC_UI' in w;
};
export const checkIfFunctionalConsentGiven = async (): Promise<boolean | undefined> => {
    if (!hasUCUILoaded(window)) {
        return;
    }
    const services = await window.UC_UI.getServicesBaseInfo();
    return services.some(service => service.categorySlug === 'functional' && service.consent.status);
};
